import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageCount: {
    defaultMessage: 'Package {count}',
    id: 'hyM0JJ',
    description: 'label for package count',
  },
  duplicate: {
    defaultMessage: 'Duplicate',
    id: 'VnyTe3',
    description: 'duplicate button label',
  },
  delete: {
    defaultMessage: 'Delete',
    id: '+jPdNH',
    description: 'delete button label',
  },
  customPackageType: {
    defaultMessage: 'Package Type',
    id: 'NwJhgm',
    description: 'label for custom package type dropdown',
  },
  customPackageTypePlaceholder: {
    defaultMessage: 'Select a package type...',
    id: 'f5pDwR',
    description: 'placeholder for custom package type dropdown',
  },
  dimensionsProvided: {
    defaultMessage: 'Dimensions provided by carrier.',
    id: 'QB28R4',
    description: 'Tooltip shown on the dimensions input when the selected carrier package type has fixed dimensions',
  },
});
